/***
 *
 *   ACCOUNT NAV
 *   Acount sub nav that renders different options based
 *   on user permissions. Shows billing & user admin to only account owners
 *
 **********/

import { SubNav } from "components/lib";

export function AccountNav(props) {
  return (
    <SubNav
      items={[
        { link: "/app/account/profile", label: "Profile" },
        {
          link: "/app/account/signature",
          label: "Signature",
          permission: "owner",
        },
        {
          link: "/app/account/password",
          label: "Password",
        },
        { link: "/app/account/company", label: "Company", permission: "owner" },
        {
          link: "/app/account/commissions",
          label: "Commissions",
          permission: "owner",
        },
        { link: "/app/account/users", label: "Users", permission: "owner" },
      ]}
    />
  );
}
